import { render, staticRenderFns } from "./teamAnalysis.vue?vue&type=template&id=5b35551c&scoped=true"
import script from "./teamAnalysis.vue?vue&type=script&lang=ts"
export * from "./teamAnalysis.vue?vue&type=script&lang=ts"
import style0 from "./teamAnalysis.vue?vue&type=style&index=0&id=5b35551c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b35551c",
  null
  
)

export default component.exports